import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { isLoggedIn } from '../../routes/IsLoggedIn.jsx';

import Drawer from './Drawer';
import Header from './Header';
import Loader from 'components/Loader';
import OwnerCompanyBar from 'components/OwnerCompanyBar';
import useSessionGuard from 'hooks/useSessionGuard';
import { selectIsOwner } from 'Redux/slices/authSlice';
import { selectSelectedCompanyId } from 'Redux/slices/ownerSlice';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const location = useLocation();
  const loggedIn = isLoggedIn();
  const isOwner = useSelector(selectIsOwner);
  const selectedCompanyId = useSelector(selectSelectedCompanyId);
  useSessionGuard(loggedIn);

  // owner-only platform pages manage companies themselves; every other page works on the "Working on" company
  const PLATFORM_PAGES = ['/companies', '/subscriptions-plans', '/subscriptions-companies', '/business-categories'];
  const showCompanyBar = isOwner && loggedIn && !PLATFORM_PAGES.some((p) => location.pathname.startsWith(p));

  const isQrCreateRoute = location.pathname === '/qr-batch-create';
  const isScanRoute = /^\/scan\//.test(location.pathname);
  const isProdVerifyRoute = location.pathname === '/prod-verify';
  const isMyCardsRoute = location.pathname === '/my-cards';
  const isLuckyDrawRoute = location.pathname === '/lucky-draw';
  const isLuckyDrawEntryRoute = /^\/lucky-draw\/[^/]+$/.test(location.pathname);

  useEffect(() => {
    handlerDrawerOpen(!downLG);
  }, [downLG]);

  if (menuMasterLoading) return <Loader />;

  // customer pages (rewards, offers) are stand-alone – never inside the staff header / menu, even when a staff user is signed in
  const isCustomerRoute = ['/my-rewards', '/my-offers'].includes(location.pathname);

  if (isScanRoute || (isProdVerifyRoute && !loggedIn) || isMyCardsRoute || isLuckyDrawRoute || isLuckyDrawEntryRoute || isCustomerRoute) {
    return (
      <Box
        component="main"
        sx={{
          width: 'calc(100%)',
          flexGrow: 1,
          backgroundColor: 'transparent'
        }}
      >
        {/* <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 64px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Breadcrumbs /> */}
        <Outlet />
        {/* <Footer /> */}
      </Box>
      // </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          minWidth: 0,
          flexGrow: 1,
          pt: 0,
          backgroundColor: 'transparent'
        }}
      >
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            px: { xs: 2, sm: 2.5, md: 3 },
            pt: { xs: 2, md: 2.5 },
            pb: 4,
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {showCompanyBar && <OwnerCompanyBar />}
          {/* key: switching company re-mounts the page so every list is loaded again for the new company */}
          <Outlet key={showCompanyBar ? selectedCompanyId : 'platform'} />
          {/* <Footer /> */}
        </Box>
      </Box>
    </Box>
  );
}
